import { defineMessages } from "react-intl";

export const messages = defineMessages({
  videoTabTitle: {
    id: "admin.settings.tab.video.title.label",
    defaultMessage: "Video",
    description: "Title for tab video settings",
  },
});
